import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import { observer } from "mobx-react";
import React, { forwardRef, memo } from "react";
import { Search } from "@material-ui/icons";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingStaff } from "app/services/StaffService";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { CUSTOMER_JOURNEYS } from "app/common/LocalConst";
const SearchCustomerJourneyTab = () => {
  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
           <GlobitsMultiDatePicker 
              label="Từ ngày - đến ngày" 
              name="fromDate"
              range
              rangeHover
              fromField="fromDate"
              toField="toDate"
              // format={"DD/MM/YYYY"}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingStaff}
            name="staff"
            label="Nhân viên"
            displayLabel="staffName"
            searchObject={{
              isActive: true
            }}
            ListboxComponent={forwardRef((props, ref) => {
              const { children, ...other } = props;
              return (
                <ul {...other} ref={ref}>
                  <ol>
                    <li>{children}</li>
                  </ol>
                </ul>
              );
            })}
            renderOption={(option) => renderOptionsStaff(option)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <GlobitsSelectInput
            options={CUSTOMER_JOURNEYS}
            label="Loại hành trình"
            name="seriesType"
            multiple
          />
        </Grid>
        
        <Grid item xs={12} sm={4} md={4} className="flex flex-end gap-2">
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(SearchCustomerJourneyTab));
